import { virtel_schema_smart_get } from "./ter-virtel-definition-lib";
import { _get_fixed_fields } from "./ter-virtel-utils";
import { _getParamsFromLib } from "./ter-params-utils";
import { derivatKlimaKomora, derivatKlimaKomoraSirinaVisina, derivatKlimaKomora_izracunaj_unutrasnjaoplata } from "./ter-derivat-lib-terkk-klimakomora";
import { js_utils } from "../utils/frfr-js-utils";
import { _datarender_virbom_from_single_virtel } from "./ter-virbom-datarender";


// TER DRAFTEL CODECS LIB

/*

*/


export const draftel_codecs_pack_terkk$klimakomora = {};


// ---------- CODEC SCHEMA METHODS ----------


draftel_codecs_pack_terkk$klimakomora.default_preset_state = () => {
  const preset_state = {
    _draftelschemakey: 'terkk$klimakomora',
    virtelclass: 'terkk$klimakomora',
    terkknivo: 'klimakomora', // ???
    // ID polje ne ide u preset, dobija se samo u EDIT MODE ali i tada mora biti obezbedjeno

    "sifrakomore": 'AHU',
    "nazivkomore": null,
    "nazivsistema": null,

    "unutrasnjaoplata": 'plastificirano',
    "tipkomore": 'STD:pro',
    "vrstaprofila": 'STD-50',
    "tipispuneklimakomore": 'kamenavuna',

    "flag_dimenzijekomoreunc": false,
    "_sirinakomoreoznaka": null,
    "_visinakomoreoznaka": null,
    "_sirinakomoreunc": null,
    "_visinakomoreunc": null,
    "flag_dvevelicine": false,
    "flag_dimenzijekomore2unc": false,
    "_sirinakomore2oznaka": null,
    "_visinakomore2oznaka": null,
    "_sirinakomore2unc": null,
    "_visinakomore2unc": null,

    "pozicijemodula": '',

    kolicina: 1,

    "Par6": null,
    "Par7": null,
    "Par8": null,
    "Par9": null,
    "Par10": null,
    "Par11": null,
    // "Par12": null,
    // "Par13": null,
    "Par14": null,
    "Par15": null,
    "Par16": null,
    "Par17": null,
    "Par18": null,
    "Par28": null,
    "Par29": null,
  };
  return preset_state;
};

draftel_codecs_pack_terkk$klimakomora.keys_for_direct_cloning = [
  "rev_id",
  "superkey",
  "subkey",
  "parent_subkey",
  "sifrakomore",
  "nazivkomore",
  "nazivsistema",
  "unutrasnjaoplata",
  "tipkomore",
  "vrstaprofila",
  "tipispuneklimakomore",
  "flag_dimenzijekomoreunc",
  "flag_dvevelicine",
  "flag_dimenzijekomore2unc",
  "pozicijemodula",
  "bomlevel_imported",
  "Par6",
  "Par7",
  "Par8",
  "Par9",
  "Par10",
  "Par11",
  // "Par12",
  // "Par13",
  "Par14",
  "Par15",
  "Par16",
  "Par17",
  "Par18",
  "Par28",
  "Par29",
];


// ---------- CODEC ENCODING  - DRAFTEL TO VIRBOM DIRECTION ----------


draftel_codecs_pack_terkk$klimakomora.drafel_to_virtel = (formState) => {
  // pretvara iz formState u virtel format sa ispravnim flagovima
  const sema = virtel_schema_smart_get('terkk$klimakomora');
  let state = {
    ...formState
  };
  state.flag_dvevelicine = false;
  state.flag_dimenzijekomoreunc = false; // NOVO AVGUST
  state.flag_dimenzijekomore2unc = false; // NOVO AVGUST
  state.sirinakomoreoznaka = null; // ponistavamo virtel polje
  state.visinakomoreoznaka = null; // ponistavamo virtel polje
  state.sirinakomore2oznaka = null; // ponistavamo virtel polje
  state.visinakomore2oznaka = null; // ponistavamo virtel polje
  state.sirinakomoreunc = null; // ponistavamo virtel polje
  state.visinakomoreunc = null; // ponistavamo virtel polje
  state.sirinakomore2unc = null; // ponistavamo virtel polje
  state.visinakomore2unc = null; // ponistavamo virtel polje
  // state.unutrasnjaoplata = null; // ponistavamo virtel polje
  state.unutrasnjaoplata = derivatKlimaKomora_izracunaj_unutrasnjaoplata(formState.tipkomore, formState.unutrasnjaoplata);
  // velicina 1
  if (formState.flag_dimenzijekomoreunc === true) {
    state.flag_dimenzijekomoreunc = true;
    state.sirinakomoreunc = formState._sirinakomoreunc; // uvazavamo virtel polje
    state.visinakomoreunc = formState._visinakomoreunc; // uvazavamo virtel polje
  } else {
    state.sirinakomoreoznaka = formState._sirinakomoreoznaka; // uvazavamo virtel polje
    state.visinakomoreoznaka = formState._visinakomoreoznaka; // uvazavamo virtel polje
  }
  // velicina 2 (samo ako postoje 2 velicine)
  if (formState.flag_dvevelicine === true) {
    state.flag_dvevelicine = true;
    if (formState.flag_dimenzijekomore2unc === true) {
      state.flag_dimenzijekomore2unc = true;
      state.sirinakomore2unc = formState._sirinakomore2unc; // uvazavamo virtel polje
      state.visinakomore2unc = formState._visinakomore2unc; // uvazavamo virtel polje
    } else {
      state.sirinakomore2oznaka = formState._sirinakomore2oznaka; // uvazavamo virtel polje
      state.visinakomore2oznaka = formState._visinakomore2oznaka; // uvazavamo virtel polje
    }
  };
  //
  const k_der = derivatKlimaKomoraSirinaVisina(state);
  let k_ident_temp = derivatKlimaKomora(state).ident; // ???
  const state2 = {
    virtelschemakey: 'terkk$klimakomora',
    ...state,
    ...k_der,
    calculated_ident: k_ident_temp.calculated_ident,
    flag_paired_with_smartel: true, // ovaj virtel direktno uparen sa smartel.subkey
    multitranslator_lang: "terkk$klimakomora/klimakomora",
    ..._get_fixed_fields(sema),
    ..._getParamsFromLib("terkk$klimakomora") // parametri na kraju imaju prioritet
  };
  return state2; // return virtel
};


draftel_codecs_pack_terkk$klimakomora.drafel_to_virbom = (draftel) => {
  // MAIN CONVERT METHOD
  // const sema = virtel_schema_smart_get('terkk$klimakomora');
  const virtel = draftel_codecs_pack_terkk$klimakomora.drafel_to_virtel(draftel);
  const virbom = _datarender_virbom_from_single_virtel(virtel);
  return virbom; // return virtel
};


// ---------- CODEC DECODING - VIRBOM TO DRAFTEL DIRECTION ----------


draftel_codecs_pack_terkk$klimakomora.virtel_to_draftel = (virtel) => {
  // pretvara iz virtela u formState format
  let state = {
    ...draftel_codecs_pack_terkk$klimakomora.default_preset_state(),
    ...js_utils.clone_obj_but_only_selected_keys(virtel, draftel_codecs_pack_terkk$klimakomora.keys_for_direct_cloning)
  };
  state.unutrasnjaoplata = derivatKlimaKomora_izracunaj_unutrasnjaoplata(state.tipkomore, state.unutrasnjaoplata);
  // velicina 1
  if (virtel.flag_dimenzijekomoreunc === true) {
    state._sirinakomoreunc = virtel.sirinakomoreunc;
    state._visinakomoreunc = virtel.visinakomoreunc;
  } else {
    state._sirinakomoreoznaka = virtel.sirinakomoreoznaka;
    state._visinakomoreoznaka = virtel.visinakomoreoznaka;
  }
  // velicina 2 (samo ako postoje 2 velicine)
  if (virtel.flag_dvevelicine === true) {
    if (state.flag_dimenzijekomore2unc === true) {
      state._sirinakomore2unc = virtel.sirinakomore2unc;
      state._visinakomore2unc = virtel.visinakomore2unc;
    } else {
      state._sirinakomore2oznaka = virtel.sirinakomore2oznaka;
      state._visinakomore2oznaka = virtel.visinakomore2oznaka;
    }
  }
  //
  return state; // return formState
};

